export let bikFormCtrl = (function(angular) {
    window.app.controller('bikFormCtrl', ['$http', '$scope', '$compile', function ($http, $scope, $compile){
        //test
        
        $scope.bikForm = {
          birthDate: new Date()
        };
        $scope.formErrorText;

        $scope.myDate = new Date();
        $scope.dateRange = {
            min: new Date(
                $scope.myDate.getFullYear() - 100,
                $scope.myDate.getMonth(),
                $scope.myDate.getDate()),
            max: new Date(
                $scope.myDate.getFullYear() - 18,
                $scope.myDate.getMonth(),
                $scope.myDate.getDate()),
        };

        $scope.setInputVal = function(formName){
            var inputs = $('[name="' + formName + '"] *[data-default-value]');
            //console.log(inputs)
            inputs.each(function(){
                var name = $(this).attr('name');
                var defVal = $(this).attr('data-default-value');
                if(defVal === 'true') defVal = true;
                if(defVal === 'false') defVal = false;
                if(name == 'birthDate' && defVal) defVal=new Date(defVal);
                
                $scope.bikForm[name] = defVal;
            })
        }

        $scope.getBikForm = function(){
            var data = {};
            var inputs = $('[name="bikReportForm"] *[data-default-value]');
            
            inputs.each(function(){
                var name = $(this).attr('name');
                var value = $(this).val();
                var defVal = $(this).attr('data-default-value');
                var tagName = $(this)[0].tagName;
                
                if(tagName == 'MD-CHECKBOX'){
                    value = $(this).attr('aria-checked');
                    if(value === 'true') value = true;
                    if(value === 'false') value = false;
                } 
                if(tagName == 'MD-SELECT'){
                    value = $(this).siblings('select').children('option[selected]').val();
                    if(value === '1') value = 1;
                    if(value === '0') value = 0;
                }
                if(value || typeof(value) === "number") data[name] = value;
            })
            console.log(data);
            return data;
        }

        // $scope.bikRequest = function(){
        //     $scope.switchLoader(true);
        //     $http({
        //         method: 'POST',
        //         url: url,
        //         data: data(),
        //         headers: {  'Content-Type': 'application/json',
        //                     'Authorization': 'Bearer ' + $scope.getCookie('_oreo')}
        //     }).then(function successCallback(response) {
        //         successFunc(response);
        //         $scope.switchLoader(false);
        //     }, function errorCallback(response) {
        //         console.log("ajax fail...(" + response.status + ").");
        //         $scope.switchLoader(false);
        //     });
    	// }
        $scope.parseResponse = function(response){
            var response = response;
            console.log(response.data);
            if(!response.data.success){
                if(response.data.errors.hasFreeReport){
                    $scope.formErrorText = response.data.errors.hasFreeReport;
                }
                else $scope.formErrorText = 'Wniosek nie został wysłany. Sprawdź proszę, poprawność wprowadzonych danych.';
            }
            else $scope.redirect('office/user-office');
                       
        }

        $scope.sendBikData = function(){
            $scope.formErrorText = '';
            if($scope.checkBikReportForm() === true){
                $scope.sendXHR({
                    url: '/rest/credit-vision/get-bik-report',
                    data: $scope.getBikForm,
                    successFunc: $scope.parseResponse,
                    headers: {  'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + $scope.getCookie('_oreo'),
                            },
                    dataAsParam: false
                });
            }
            else $scope.formErrorText = $scope.checkBikReportForm();
        }
        
        $scope.checkBikReportForm = function(){
    		return $scope.checkAdult();
        }

        $scope.checkAdult = () => {
            let today = new Date().getTime();
            let todayMinusOneDay = new Date(today - (1000 * 60 * 60 *24));
            let bDay = new Date($scope.bikForm.birthDate);
            let fullYears = new Date(todayMinusOneDay - bDay).getFullYear() - 1970;

    		if(fullYears >= 101) return 'Jesteś starszy od mojej prababci / pradziadka';
            if(fullYears >= 18) return $scope.checkSexCodeInPesel();
    		if(fullYears <  0) return 'Narodziłeś się w przyszłości???';
            else return 'Nie masz jeszcze 18 lat';
        }

        $scope.checkSexCodeInPesel = function(){
            var pesel = $('[name="pesel"]').val();
            var sex = +($('option[ng-value="bikForm.sex"]').val());
            var checkCode = pesel[pesel.length-2] % 2;
            if(sex === checkCode) return $scope.checkBdayCodeInPesel(pesel);
            else  return 'Płeć albo numer PESEL wprowadzony jest nieprawidłowo';
        }

      $scope.birdthaDate = function(){
        var date = function(){
          if(!$scope.bikForm.birthDate){
            return new Date($('#birthDate').attr('data-default-value'))
          }
          return new Date($scope.bikForm.birthDate)

        };
        var year = ''+(date().getFullYear());
        var month = function(){
          if((date().getMonth()+1+'').length < 2){
            return '0'+(date().getMonth()+1)
          }
          return date().getMonth()+1+''
        };
        var day = function(){
          if((date().getDate() + '').length < 2){
            return '0'+(date().getDate())
          }
          return date().getDate()+''
        };
        return year+'-'+month()+'-'+day()
      }


        $scope.checkBdayCodeInPesel = function(pesel){
            var bDate = $scope.birdthaDate().split('-');
            var yy = bDate[0].split('').splice(2, 2).join('');
            var mm = bDate[1];
            var dd = bDate[2];
            if(+(bDate[0]) >= 2000) mm = +(mm) + 20 + '';
            var createdPesel = pesel.split('').splice(0, 6).join('');
            if(createdPesel === yy+mm+dd) return $scope.checkFormatPesel(pesel);
            else return 'Data urodzenia albo numer PESEL wprowadzony jest nieprawidłowo';
        }

        $scope.checkFormatPesel = function(pesel){
            var P = pesel;
            var lastDigit = +P[P.length-1];
            var checkSumm = function(){
                var summ =  +P[0]*1+
                            +P[1]*3+
                            +P[2]*7+
                            +P[3]*9+
                            +P[4]*1+
                            +P[5]*3+
                            +P[6]*7+
                            +P[7]*9+
                            +P[8]*1+
                            +P[9]*3;
                return summ;
            };
            var checkDigt = checkSumm() % 10;
            //console.log(checkDigt);

            if(checkDigt === 0 || checkDigt === 5){
                if(checkDigt === lastDigit) return $scope.checkIDnumber();
                else return 'Numer PESEL wprowadzony jest nieprawidłowo';
            }
            else{
                checkDigt = 10-checkDigt;
                if(checkDigt ===  lastDigit) return $scope.checkIDnumber();
                else return 'Numer PESEL wprowadzony jest nieprawidłowo';
            }
        }
        $scope.checkIDnumber = function(){
            var cardNum = $('[name="socialNumber"]').val();
            var letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
            var getValue = function(w){return +letters.indexOf(w)+10};
            var weight =  [7, 3, 1, 0, 7, 3, 1, 7, 3];
            
           	var setVal = function(){ 
    			var val = [];
    			for(var i = 0; i < cardNum.length; i++){
    				var w = cardNum[i];
    				if(i < 3) val.push(getValue(w))
    				else val.push(+w)
    			}
    			return val
            }
            var valueArr = function(){
    			var valueArr = [];
    			for(var i = 0; i<setVal().length; i++){
    				valueArr.push(+setVal()[i]*+weight[i]);
    			}
    			//console.log('result arr - ' + valueArr)
    			return valueArr
            }
            var checkDigit = function(){
    			var summ = 0;
    			for(var i = 0;i < valueArr().length; i++){
    				summ +=  valueArr()[i];
    			}
    			//console.log('summ - ' + summ, 'checkDigit - ' + summ%10)
    			return summ%10
            }
            var checkID = function(){
    			if(checkDigit() == cardNum[3]) return true
    			else return 'Numer dowodu osobistego wprowadzony jest nieprawidłowo';
    		}
    		return checkID();
        }


    }]);
})(window.angular);



// WEBPACK FOOTER //
// src/js/controllers/user/bikFormCtrl.js